import BasicInfoItem from './basic-info-item'
import { SubTypeOption } from '../../../../../../api/gms/group-category/group-category-api-state';

interface Props {
    selectChannelType: SubTypeOption | null
    showInput: boolean;
    selectProposalAs: string | undefined
    sECRegisteredNameRenew: string | null
    isRenew: boolean;
    channelSubName: string | null
    channelSubNumber: string | null
    channelSubEmail: string | null
}

export default function ChannelTypeReview({channelSubNumber, channelSubEmail, selectChannelType, showInput, selectProposalAs, sECRegisteredNameRenew, isRenew, channelSubName}: Props) {

    return (
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
            {/* ================================================= */}
            {/* CHANNEL */}
            {/* ================================================= */}
            <div className="min-w-0">
                <div className="mb-3 border-b border-gray-100 pb-2">
                    <h4 className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                        Channel Information
                    </h4>
                </div>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <BasicInfoItem
                        label="Channel Type"
                        value={selectChannelType?.name ?? ""}
                    />
                    {showInput && (
                        <>
                            <BasicInfoItem
                                label={`${selectChannelType?.name ?? "Channel"} Name`}
                                value={channelSubName || ""}
                            />
                            <BasicInfoItem
                                label={`${selectChannelType?.name ?? "Channel"} Number`}
                                value={channelSubNumber || ""}
                            />
                            <BasicInfoItem
                                label={`${selectChannelType?.name ?? "Channel"} Email`}
                                value={channelSubEmail || ""}
                            />
                        </>
                    )}
                </div>
            </div>
            {/* ================================================= */}
            {/* PROPOSAL */}
            {/* ================================================= */}
            <div className="min-w-0">
                <div className="mb-3 border-b border-gray-100 pb-2">
                    <h4 className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                        Proposal Information
                    </h4>
                </div>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <BasicInfoItem
                        label="Proposal As"
                        value={
                            selectProposalAs ?? ""
                        }
                    />
                    {isRenew && (
                        <BasicInfoItem
                            label="Renew Name"
                            value={
                                sECRegisteredNameRenew ?? ""
                            }
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
